import { decode } from 'html-entities';
import parse from 'html-react-parser';

export type HtmlParserType = string | JSX.Element | JSX.Element[] | undefined;

const stripTags = (
  original: string,
  pattern: RegExp = /(<([^>]+)>)/gi
): string => original.replace(pattern, '');

export const getParsedHtml = (inputString: string): HtmlParserType => {
  const spanPattern = /<\/?span[^>]*>/g;
  return parse(stripTags(decode(inputString), spanPattern));
};

export const getDecodedStrippedString = (
  original: string,
  pattern: RegExp = /(<([^>]+)>)/gi
): string => decode(stripTags(original, pattern));
